import { UserTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { UserRole } from 'shared/types/userRole';

const USER_ROLE_EXPLANATION_LABEL_KEYS: Record<UserRole, TranslationKey> = {
  [UserRole.visible_no_access]: UserTranslationKeys.explanationVisibleNoAccess,
  [UserRole.standard]: UserTranslationKeys.explanationStandard,
  [UserRole.manager]: UserTranslationKeys.explanationManager,
  [UserRole.viewer]: UserTranslationKeys.explanationViewer,
  [UserRole.projectAdmin]: UserTranslationKeys.explanationProjectAdmin,
  [UserRole.organizationAdmin]: UserTranslationKeys.explanationOrganizationAdmin,
  [UserRole.superAdmin]: UserTranslationKeys.explanationSuperAdmin,
};

export function userRoleExplanationLabelKey(role: UserRole): TranslationKey {
  return USER_ROLE_EXPLANATION_LABEL_KEYS[role];
}
